import { $t } from '@/i18n';
// 对应 page.type 字段
export const TYPE = {
    Page: 'page', // 低码页面
    Code: 'code', // 本地开发页面
    AI: 'ai', // AI页面
};
// 对应 page.pageType 字段
export const PAGE_TYPE = {
    CONTENT: 'content',
    PAGELET: 'pagelet',
    NAV: 'nav',
    SIDEBAR: 'sidebar',
    HEADER: 'header',
    FOOTER: 'footer',
    DATA_TABLE: 'datatable',
    MODAL: 'modal',
};
export const PAGE_TYPE_OPTIONS = [
    {
        value: 'content',
        label: $t('k_9701c2ec'),
    },
    {
        value: 'pagelet',
        label: $t('k_2f628aaf'),
    },
    {
        value: 'nav',
        label: $t('k_24f6ce51'),
    },
    {
        value: 'sidebar',
        label: $t('k_aa07e056'),
    },
    {
        value: 'header',
        label: $t('k_12849352'),
    },
    {
        value: 'footer',
        label: $t('k_97542633'),
    },
    {
        value: 'modal',
        label: $t('k_6bc5d09c'),
    },
];
export const LAYOUT_TYPE_OPTIONS = [
    {
        value: 'header-sidebar-content',
        label: $t('k_4f7290aa'),
    },
    {
        value: 'header-content',
        label: $t('k_f2466883'),
    },
    {
        value: 'sidebar-content',
        label: $t('k_6d149e31'),
    },
    {
        value: 'content',
        label: $t('k_7454f20'),
    },
];
export const SCROLL_MODE_OPTIONS = [
    {
        value: 'system',
        label: $t('k_6c269693'),
    },
    {
        value: 'fix-top',
        label: $t('k_dce4646'),
    },
    {
        value: 'not-fix-top',
        label: $t('k_fbe7ae1e'),
    },
];
export const WATERMARK_OPTIONS = [
    {
        value: 'system',
        label: $t('k_6c269693'),
    },
    {
        value: 'on',
        label: $t('k_bc84d7ca'),
    },
    {
        value: 'off',
        label: $t('k_4a7e579c'),
    },
];
